import React from 'react';
import Skeleton from './Skeleton';

const QuickAccessCard = ({ label, value, valueLabel, valueColor, projected, projectedColor, period, accent, loading, onClick }) => (
  <button
    className={`fd-quick-card${accent ? ` accent-${accent}` : ''}`}
    type="button"
    onClick={onClick}
  >
    <span className="fd-quick-label">{label}</span>
    {valueLabel !== undefined && <span className="fd-quick-value-label">{valueLabel}</span>}
    {value !== undefined && (
      loading
        ? <Skeleton width={120} height={20} style={{ marginTop: 4 }} />
        : <span className={`fd-quick-value ${valueColor || ''}`}>{value}</span>
    )}
    {projected !== undefined && (
      loading
        ? <Skeleton width={120} height={16} style={{ marginTop: 6 }} />
        : (
          <span className="fd-quick-projected">
            <span className="fd-quick-projected-label">Saldo Projetado</span>
            <span className={`fd-quick-projected-value ${projectedColor || ''}`}>{projected}</span>
          </span>
        )
    )}
    {period !== undefined && (
      loading
        ? <Skeleton width={40} height={10} style={{ marginTop: 4 }} />
        : <span className="fd-quick-period">{period}</span>
    )}
  </button>
);

export default QuickAccessCard;
